import "core-js/modules/es.string.trim.js";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonPrimary, CloseButton, colors, Modal, Heading, HSpacer, TextDescription, TextArea, When, LoadingDot } from '@aftersale-next/ui';
import * as trackingActions from '../../config/constants/tracking-actions';
import { Flex } from '@chakra-ui/react';
import { validateActionDescription } from './utils/validateActionDescription';
import { BsX } from 'react-icons/bs';
import { ampli } from '@aftersale-next/ampli';
import { AMPLI_SOURCE_ENV } from '../../../../../apps/customer/config/env';
import { useEcommerceName } from '@aftersale-next/atoms';
import { useUserInfo } from '../../hooks/use-user-info';
export default function ActionHelp(_ref) {
  var isLoading = _ref.isLoading,
      mutate = _ref.mutate,
      id = _ref.id;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      isModalOpen = _useState[0],
      setIsModalOpen = _useState[1];

  var _useState2 = useState(''),
      description = _useState2[0],
      setDescription = _useState2[1];

  var _useState3 = useState(false),
      error = _useState3[0],
      setError = _useState3[1];

  var _useEcommerceName = useEcommerceName(),
      _useEcommerceName2 = _slicedToArray(_useEcommerceName, 1),
      name = _useEcommerceName2[0];

  var customerDocument = useUserInfo('document');

  var handleModal = function handleModal() {
    setIsModalOpen(!isModalOpen);
  };

  var afterSubmit = function afterSubmit() {
    ampli.identify(customerDocument || undefined, {
      UserType: 'Consumidor'
    });
    ampli.askEcommerceHelp({
      EcommerceName: name,
      PackageId: id,
      Enviroment: AMPLI_SOURCE_ENV
    });
    setDescription('');
    setError(false);
    setIsModalOpen(false);
  };

  var handleSubmit = function handleSubmit() {
    validateActionDescription({
      text: description,
      onValid: function onValid() {
        mutate({
          action: trackingActions.HELP,
          informedData: description,
          id: id
        });
        afterSubmit();
      },
      onError: function onError() {
        return setError(true);
      }
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ButtonPrimary, {
      id: trackingActions.HELP,
      disabled: isLoading,
      bgColor: colors.royal,
      onClick: handleModal,
      children: [/*#__PURE__*/_jsx(When, {
        value: !isLoading,
        children: t('ACTION_NEED_HELP')
      }), /*#__PURE__*/_jsx(When, {
        value: isLoading,
        children: /*#__PURE__*/_jsx(LoadingDot, {})
      })]
    }), /*#__PURE__*/_jsxs(Modal, {
      isOpen: isModalOpen,
      onClose: handleModal,
      children: [/*#__PURE__*/_jsxs(Flex, {
        justify: "center",
        align: "center",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(Heading, {
          content: t('OFFER_HELP')
        }), /*#__PURE__*/_jsx(CloseButton, {
          onClick: handleModal,
          children: /*#__PURE__*/_jsx(BsX, {})
        }), /*#__PURE__*/_jsx(HSpacer, {
          space: "16px"
        }), /*#__PURE__*/_jsx(TextDescription, {
          center: true,
          children: t('OFFER_HELP_DESCRIPTION')
        })]
      }), /*#__PURE__*/_jsx(HSpacer, {
        space: "16px"
      }), /*#__PURE__*/_jsxs(Flex, {
        justifyContent: "center",
        flexDirection: "column",
        w: "100%",
        children: [/*#__PURE__*/_jsx(TextArea, {
          id: "help-textarea",
          name: "help-textarea",
          placeholder: t('TELL_MORE_ABOUT_SOLICITATION'),
          value: description,
          label: t('DESCRIPTION'),
          error: error,
          onChange: function onChange(value) {
            return setDescription(value);
          },
          maxWidth: "100%",
          rows: 4,
          maxLength: 1000
        }), /*#__PURE__*/_jsx(HSpacer, {
          space: "32px"
        }), /*#__PURE__*/_jsx(ButtonPrimary, {
          bgColor: colors.royal,
          onClick: handleSubmit,
          disabled: !description.trim() || isLoading,
          isLoading: isLoading,
          children: t('SEND')
        })]
      })]
    })]
  });
}